const showLoadedImg = (el, onload = true) => {
	let img = el;

	if (el.tagName.toLowerCase() === 'picture') {
		img = el.querySelector('img');
	}

	if (img.tagName.toLowerCase() === 'img' && onload) {
		img.onload = () => {
			img.style.opacity = 1;

			if (img.classList.contains('lozad-auto')) {
				img.style.height = 'auto';
			}
		};
	} else {
		setTimeout(() => {
			img.style.opacity = 1;

			if (img.classList.contains('lozad-auto')) {
				img.style.height = 'auto';
			}
		}, 50);
	}
}

export default function init() {
	window.lozadObserver = lozad('.lozad', {
		loaded: function (el) {
			showLoadedImg(el, !document.body.classList.contains('-firefox'));
		}
	});

	lozadObserver.observe();
}